import React from 'react';
import styled from 'styled-components';
import { DarkCard } from './DashboardStyles';

const FunnelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0;
`;

const FunnelItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const LayerDescription = styled.div`
  font-size: 11px;
  color: #888;
  margin-top: 4px;
  text-align: center;
  max-width: 90%;
`;

const FunnelLayer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${props => props.bg || '#BA955E'};
  background: linear-gradient(90deg, ${props => props.bg || '#BA955E'} 0%, ${props => props.bg ? `${props.bg}cc` : '#BA955Ecc'} 100%);
  color: #fff;
  border-radius: 6px;
  width: ${props => props.width || '100%'};
  height: 54px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  padding: 4px;

  .layer-value {
    font-weight: 700;
    font-size: 18px;
    line-height: 1;
  }

  .layer-name {
    font-size: 11px;
    font-weight: 400;
    opacity: 0.9;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 2px;
  }

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
`;

const ConversionFunnelCard = ({ data = [] }) => {
    const widths = ['100%', '85%', '70%', '55%', '40%'];

    return (
        <DarkCard>
            <div className="card-title">Funnel de Conversión</div>
            <FunnelWrapper>
                {data.map((layer, i) => (
                    <FunnelItem key={layer.name}>
                        <FunnelLayer bg={layer.fill} width={widths[i] || '40%'}>
                            <span className="layer-value">{layer.value}%</span>
                            <span className="layer-name">{layer.name}</span>
                        </FunnelLayer>
                        {layer.description && <LayerDescription>{layer.description}</LayerDescription>}
                    </FunnelItem>
                ))}
            </FunnelWrapper>
        </DarkCard>
    );
};

export default ConversionFunnelCard;
